import React from 'react';

interface CardProps { title?: string; children: React.ReactNode; style?: React.CSSProperties; }

export const Card: React.FC<CardProps> = ({ title, children, style }) => (
  <div style={{
    background: '#fff', border: '0.5px solid rgba(0,0,0,0.12)',
    borderRadius: 12, padding: '14px 16px', ...style,
  }}>
    {title && (
      <div style={{ fontSize: 11, fontWeight: 500, color: '#888780', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 10 }}>
        {title}
      </div>
    )}
    {children}
  </div>
);
